module.exports = __webpack_public_path__ + "images/empty-states/mbtv-empty.abb6d1133a3fb15b1b29.svg";